"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
class Collection {
    constructor(items = []) {
        this.items = [];
        this.items = items;
    }
    get(index) {
        return this.items[index];
    }
    add(item) {
        this.items.push(item);
        return this;
    }
    removeAt(index) {
        const item = this.items[index];
        if (item) {
            this.items.splice(index, 1);
        }
        return item;
    }
    remove(item) {
        const index = this.items.indexOf(item);
        return this.removeAt(index);
    }
    forEach(callback) {
        this.items.forEach(callback);
        return this;
    }
    map(callback) {
        return this.items.map(callback);
    }
    find(callback) {
        return this.items.find(callback);
    }
    filter(callback) {
        return new Collection(this.items.filter(callback));
    }
    sort(callback) {
        return new Collection(this.items.sort(callback));
    }
    reduce(first, callback) {
        return this.items.reduce(callback, first);
    }
    count() {
        return this.items.length;
    }
    getArray() {
        return this.items;
    }
    first() {
        return this.get(0);
    }
}
exports.default = Collection;
